import { useNavigate } from "react-router-dom";

const AboutHome = ({ content }) => {
  const navigate = useNavigate();
  const aboutText =
    content.homeAboutSectionText ||
    `${content.doctorName}، ${content.doctorTitle} و متخصص ${content.doctorSpecialty}`;

  return (
    <div className="about-home iran-sans">
      <div className="about-home-card">
        <div className="about-home-accent" />
        <span className="about-home-quote" aria-hidden="true">
          ”
        </span>

        {(content.doctorTitle || content.doctorSpecialty) && (
          <div className="about-home-meta">
            {content.doctorTitle && (
              <span className="about-home-chip">{content.doctorTitle}</span>
            )}
            {content.doctorSpecialty && (
              <span className="about-home-chip">{content.doctorSpecialty}</span>
            )}
          </div>
        )}

        <p className="about-home-text">{aboutText}</p>

        <button
          type="button"
          className="about-home-more"
          onClick={() => navigate("/about")}
        >
          ادامه مطلب
          <span className="about-home-more-arrow">←</span>
        </button>
      </div>

      <style jsx>{`
        .about-home {
          width: 100%;
        }

        .about-home-card {
          position: relative;
          background: linear-gradient(180deg, #ffffff 0%, #f6faf7 100%);
          border: 1px solid rgba(5, 50, 81, 0.08);
          border-radius: 18px;
          box-shadow: 0 10px 28px rgba(5, 50, 81, 0.06);
          padding: 2rem 2.4rem 1.6rem;
          overflow: hidden;
        }

        .about-home-accent {
          position: absolute;
          top: 1.4rem;
          bottom: 1.4rem;
          right: 0;
          width: 4px;
          border-radius: 4px 0 0 4px;
          background: linear-gradient(180deg, #7cc890 0%, #053251 100%);
        }

        .about-home-quote {
          position: absolute;
          top: 0.2rem;
          left: 1.4rem;
          font-size: 5.5rem;
          line-height: 1;
          color: #7cc890;
          opacity: 0.18;
          font-family: Georgia, serif;
          pointer-events: none;
          user-select: none;
        }

        .about-home-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-bottom: 1.1rem;
        }

        .about-home-chip {
          display: inline-flex;
          align-items: center;
          background: rgba(124, 200, 144, 0.14);
          color: #053251;
          border: 1px solid rgba(124, 200, 144, 0.35);
          border-radius: 999px;
          padding: 0.25rem 0.85rem;
          font-size: 0.82rem;
          font-weight: 600;
        }

        .about-home-text {
          margin: 0;
          color: #2c4a5e;
          font-size: 1.08rem;
          font-weight: 400;
          line-height: 2;
          text-align: justify;
          white-space: pre-wrap;
        }

        .about-home-more {
          display: inline-flex;
          align-items: center;
          gap: 0.4rem;
          margin-top: 1.4rem;
          padding: 0;
          border: none;
          background: transparent;
          color: #3a8b4f;
          font-family: inherit;
          font-size: 0.95rem;
          font-weight: 700;
          cursor: pointer;
          transition: color 0.25s ease, gap 0.25s ease;
        }

        .about-home-more-arrow {
          display: inline-block;
          transition: transform 0.25s ease;
        }

        .about-home-more:hover {
          color: #053251;
        }

        .about-home-more:hover .about-home-more-arrow {
          transform: translateX(-4px);
        }

        @media (max-width: 767.98px) {
          .about-home-card {
            padding: 1.5rem 1.3rem 1.3rem;
            border-radius: 14px;
          }

          .about-home-quote {
            font-size: 4rem;
            left: 0.8rem;
          }

          .about-home-text {
            font-size: 0.98rem;
            line-height: 1.9;
          }
        }
      `}</style>
    </div>
  );
};

export default AboutHome;
